export default __webpack_public_path__ + "static/media/ls-warehouse-losses.73284d7b.svg";